/**
 * Mocking client-server processing
 */
const _products = [

    // ========================================
    // PACKAGE
    // 10x8 print £10
    //
    // 3 in the basket £27
    // 4 in the basket £35
    // 5 in the basket £42
    // ========================================

    // Products
    { product_code: 'PKA-10X8', type: 'single', image: 'https://schoolphotos.ams3.digitaloceanspaces.com/products/pb-a1.jpg', thumbnail: 'https://schoolphotos.ams3.digitaloceanspaces.com/products/thumbnail/pb-a1.jpg', package: '10 x 8" Image', content: '1x 10x8" print image', price: 10.00, published: true, },

]

export default {
  getProducts (cb) {
    setTimeout(() => cb(_products), 0)
  },

  buyProducts (products, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      (Math.random() > 0.5 || navigator.userAgent.indexOf('PhantomJS') > -1)
        ? cb()
        : errorCb()
    }, 100)
  }
}
